export const SUCCESS_APPROVED_TIME_MESSAGE = 'Successfully approved time';
export const SUCCESS_REJECTED_TIME_MESSAGE = 'Successfully rejected time';

export const ERROR_APPROVE_TIME_MESSAGE = 'Error while approving time';
export const ERROR_REJECT_TIME_MESSAGE = 'Error while rejecting time';
